import { ENTITY_FEATURE_CATEGORY_TYPE, ENTITY_FEATURE_CATEGORY_TYPE_MAP, EntityFeatureCategoryType } from "./entity-feature-category-type.model";

export class EntityFeatureBase {
    
    id!: number
    category!: string
    value!: string
    entityId!: number

    static fromEntityFeature(entityFeature: EntityFeature): EntityFeatureBase {
        let current = new EntityFeatureBase()
        Object.assign(current, entityFeature)

        return current
    }

    static categoryValueToText(c: String): string {
        const entry = ENTITY_FEATURE_CATEGORY_TYPE.find(item => item.id === c)
        return entry ? entry.name : "Desconegut"
    }

    static categoryTypeToText(c: EntityFeatureCategoryType): string {
        return ENTITY_FEATURE_CATEGORY_TYPE_MAP.get(c) || "Desconegut"
    }

    static cmp(a: EntityFeatureBase, b: EntityFeatureBase): number {
        if (a.category > b.category) {
            return 1
        }
        return -1
    }

}

export interface EntityFeature extends EntityFeatureBase {

}
